import { Locale } from "@linkfluence/models/locale";
import { GeoPlace, Towns } from "@radarly/models/geo";
import { RadarlyAPI } from "./base";

export class GeoAPI extends RadarlyAPI {
  public async getGeoPlaces(ids: string[], locale: Locale) {
    return await this.post<GeoPlace[]>("/geos.json", {
      locale,
      ids: ids.map((id) => (id.startsWith("-") ? id.substring(1) : id)),
    });
  }

  public async getTowns(focuses: number[], projectID: number, locale: Locale) {
    return await this.post<Towns>(
      `/projects/${projectID}/insights/geo/town.json?locale=${locale}`,
      {
        clause: { and: [{ focuses }] },
        interval: "day",
        metrics: ["doc"],
      },
      null
    );
  }
}
